import LogoMarkV2 from './LogoMarkV2';
import LogoWordV2 from './LogoWordV2';
import LogoMark from './old/LogoMark';
import LogoWord from './old/LogoWord';

export { LogoMark, LogoWord, LogoMarkV2, LogoWordV2 };
